import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["drive"]
  static targets = ["defaultPanel", "selectionPanel", "selectionCount", "shareButton"]
  static values = {
    itemsSelected: { type: String, default: "items selected" }
  }

  setSelectionMode(count) {
    const selected = count > 0

    if (this.hasDefaultPanelTarget) {
      this.defaultPanelTarget.classList.toggle("d-none", selected)
    }
    if (this.hasSelectionPanelTarget) {
      this.selectionPanelTarget.classList.toggle("d-none", !selected)
    }
    if (this.hasSelectionCountTarget) {
      this.selectionCountTarget.textContent = `${count} ${this.itemsSelectedValue}`
    }
    if (this.hasShareButtonTarget) {
      this.shareButtonTarget.disabled = count !== 1
    }
  }

  uploadFiles(event) {
    event.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.uploadFiles()
    }
  }

  uploadFolder(event) {
    event.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.triggerFolderInput()
    }
  }

  clearSelection(event) {
    event?.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.clearSelection()
    }
  }

  downloadSelected(event) {
    event.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.downloadSelected()
    }
  }

  shareSelected(event) {
    event.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.shareSelected()
    }
  }

  openMoveModal(event) {
    event.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.openMoveModal()
    }
  }

  deleteSelected(event) {
    event.preventDefault()
    if (this.hasDriveOutlet) {
      this.driveOutlet.deleteSelected()
    }
  }

  openNewFolderModal(_event) {
    // Modal opens automatically via data-bs-toggle
  }
}
